import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SearchComponent } from './components/search/search.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MenuMobileComponent } from './components/menu-mobile/menu-mobile.component';
import { CardsComponent } from './components/cards/cards.component';
import { HttpClientModule } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
import { CardsClienteComponent } from './components/cards-cliente/cards-cliente.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { BannersComponent } from './components/banners/banners.component';


@NgModule({
  declarations: [
    MenuMobileComponent,
    CardsComponent,
    SearchComponent,
    CardsClienteComponent,
    BannersComponent

   ],
  imports: [
    CommonModule,
    HttpClientModule,
    MatDialogModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    RouterModule,
    ReactiveFormsModule,
  ],
  exports: [
    MenuMobileComponent,
    SearchComponent,
    CardsComponent,
    CardsClienteComponent,
    MatProgressSpinnerModule,
    MatTableModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    BannersComponent
  ]
})
export class SharedModule { }
